import {
  GET_TOUR_PROGRESS_REQUEST,
  GET_TOUR_PROGRESS_SUCCESS,
  GET_TOUR_PROGRESS_FAIL,
  UPDATE_TOUR_PROGRESS_REQUEST,
  UPDATE_TOUR_PROGRESS_SUCCESS,
  UPDATE_TOUR_PROGRESS_FAIL,
} from "../constants/guidedTourConstants";

export const tourProgressReducer = (
  state = { loading: false, updating: false, data: null, error: null },
  action
) => {
  switch (action.type) {
    case GET_TOUR_PROGRESS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_TOUR_PROGRESS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case GET_TOUR_PROGRESS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_TOUR_PROGRESS_REQUEST:
      return { ...state, updating: true };
    case UPDATE_TOUR_PROGRESS_SUCCESS:
      return { ...state, updating: false };
    case UPDATE_TOUR_PROGRESS_FAIL:
      return { ...state, updating: false };
    default:
      return state;
  }
};
